import './styles.scss'
import {IContainersPerMonth} from '../../../api/ContainersPerMonth/ContainersPerMonth.types'
import {IWidgetResponse} from '../../../api/Base/Base.types'
import WidgetNivoBase from "../Widget.nivo.base";
import NumberUtils from "../../../utils/number.utils";

interface Props {
    data?: IWidgetResponse<IContainersPerMonth>
}

function ContainersPerMonth({data}: Props) {
    function getData() {
        if (data) {
            return data.data.map(d => ({date: `${d.month}/${d.year}`, containerCount: d.containerCount}));
        }
    }          

    return (
        <div className="containers-per-month">
           
            <WidgetNivoBase.Bar
                title="Containers Per Month"
                data={getData()}
                keys={["containerCount"]}
                indexBy="date"
                axisLeftName="Containers"
                axisBottomName="Date (MM/YYYY)"
                axisBottomRotation={-45}
                formatValue={v => NumberUtils.toShortened(v, 2)}
                tooltip={({value, color}) => (
                    <div style={{padding: 12, color, background: "#222222", borderRadius: 10}}>
                        <strong>{NumberUtils.numberWithCommas(value)}</strong>
                    </div>
                )}
            />
        </div>
    )
}

export default ContainersPerMonth;